import React from 'react';
import { IconBase } from '../Base';
export const IconChevronRight = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M8.33333 13.3333L11.6667 9.99996L8.33333 6.66663", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Right.js.map